import axios from "axios";
import { useQuery } from "@tanstack/react-query";

export const BACKEND = process.env.REACT_APP_BACKEND_URL;
export const api = axios.create({ baseURL: `${BACKEND}/api` });

const get = (url, params) => api.get(url, { params }).then((r) => r.data);

export const useCategories = () => useQuery({ queryKey: ["categories"], queryFn: () => get("/categories") });
export const useProducts = (params = {}) => useQuery({ queryKey: ["products", params], queryFn: () => get("/products", params) });
export const useProduct = (slug) => useQuery({ queryKey: ["product", slug], queryFn: () => get(`/products/${slug}`), enabled: !!slug });
export const useContent = (kind) => useQuery({ queryKey: ["content", kind], queryFn: () => get(`/content/${kind}`) });
export const useSettings = () => useQuery({ queryKey: ["settings"], queryFn: () => get("/settings"), staleTime: 300000 });

export const fileUrl = (u) => (!u ? "" : u.startsWith("/api/") ? `${BACKEND}${u}` : u);
export const productUrl = (p) => `/products/${p.category}/${p.slug}`;

export async function uploadFile(file, kind = "attachment") {
  const fd = new FormData();
  fd.append("file", file);
  fd.append("kind", kind);
  return (await api.post("/uploads", fd)).data;
}

export const errMsg = (e) => {
  const d = e?.response?.data?.detail;
  if (Array.isArray(d)) return d.map((x) => `${x.loc?.slice(-1)[0]}: ${x.msg}`).join("; ");
  return d || e?.message || "Something went wrong";
};
